// ── Importaciones tal cual ──────────────────────────────
import { useEffect, useState } from "react";
import { Container, Card, Button, Table, Modal, Form, Row, Col, Badge } from "react-bootstrap";
import NavBar from '../NavBar/Navbar';
import AssignProductsModal from "./AssignProductsModal";
import { PickNGoFetchAPI } from "../../api/PickAndGo";
import { RenderIf } from "../utils/RenderIf";
import SuccessAlert from "../Alerts/SuccessAlert";
import ErrorAlert from "../Alerts/ErrorAlert";
import AppShell from "../../page/AppShell/AppShell";
import MainContent from "../MainContent/MainContent";
import './pickgo.css';
/* ─────────────────────────────────────────────────────────
   CONSTANTE ORIGINAL — intacta
───────────────────────────────────────────────────────── */
const EMPTY = {
    id: null, business_id: "", branchoffice_id: null,
    slot_minutes: 30, window_start: "8:00", window_end: "17:00",
    days_ahead: 7, lead_time_minutes: 60, is_active: true, priority: 100,
    type: "all", limit_mode: "days_ahead", start_date: "", end_date: ""
};


/* ── ICONS ── */
const IcoPng = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>;
const IcoPlus = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>;
const IcoPen = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>;
const IcoBox = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /></svg>;
const IcoCheck = () => <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoSlash = () => <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
════════════════════════════════════════════════════════ */
const PickAndGoManager = () => {



    /* ════════════════════════════════════
       LÓGICA ORIGINAL — 100% INTACTA
    ════════════════════════════════════ */
    const [rows, setRows] = useState([]);
    const [show, setShow] = useState(false);
    const [editing, setEditing] = useState(null);
    const business = JSON.parse(localStorage.getItem('user'))?.business || {};
    const token = localStorage.getItem('x-access-token');
    const branches = JSON.parse(localStorage.getItem('user'))?.branchoffices || [];
    const [showProducts, setShowProducts] = useState(false);
    const [ruleForProducts, setRuleForProducts] = useState(null);

    const getPickAndGoRulesByBusiness = async () => {
        try {
            const res = await PickNGoFetchAPI.getPickAndGoRulesByBusiness(business.id, token);
            console.log("Pick & Go rules", res);
            const data = res?.data?.rules || res?.data || [];
            setRows(Array.isArray(data) ? data : []);
        } catch (e) { ErrorAlert("No se pudo cargar", "Pick & Go", "warning"); }
    };

    useEffect(() => { getPickAndGoRulesByBusiness(); }, []);

    const openCreate = () => { setEditing({ ...EMPTY, business_id: business.id }); setShow(true); };
    const openEdit = (r) => {
        setEditing({
            ...EMPTY, ...r, is_active: !!r.is_active,
            limit_mode: r.limit_mode || "days_ahead",
            start_date: r.start_date || "",
            end_date: r.end_date || "",
            days_ahead: r.days_ahead ?? 7
        }); setShow(true);
    };

    const save = async () => {
        try {
            const payload = {
                ...editing,
                business_id: Number(editing.business_id),
                name: editing.name?.trim() || 'Sin nombre',
                branchoffice_id: editing.branchoffice_id ? Number(editing.branchoffice_id) : null,
                slot_minutes: Number(editing.slot_minutes),
                lead_time_minutes: Number(editing.lead_time_minutes),
                is_active: editing.is_active ? 1 : 0,
                priority: editing.priority ? Number(editing.priority) : 100,
                type: editing.type || "all",
                limit_mode: editing.limit_mode || "days_ahead",
                days_ahead: (editing.limit_mode || "days_ahead") === "days_ahead"
                    ? Number(editing.days_ahead) : null,
                start_date: (editing.limit_mode || "days_ahead") === "date_range"
                    ? editing.start_date || null : null,
                end_date: (editing.limit_mode || "days_ahead") === "date_range"
                    ? editing.end_date || null : null
            };
            if (editing.id) await PickNGoFetchAPI.updatePickAndGoRule(editing.id, payload, token);
            else await PickNGoFetchAPI.createPickAndGoRule(payload, token);
            SuccessAlert("Configuración guardada", "Listo");
            setShow(false);
            getPickAndGoRulesByBusiness();
        } catch (e) { ErrorAlert(e?.response?.data?.error || "Error guardando", "Pick & Go", "warning"); }
    };

    const openProducts = (r) => {
        setRuleForProducts({ id: r.id, name: r.name || `Regla #${r.id}` });
        setShowProducts(true);
    };
    /* ════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ════════════════════════════════════ */

    /* ── helpers de render ── */
    const limitLabel = (r) =>
        r.limit_mode === "date_range"
            ? `${r.start_date?.slice(0, 10) || '—'} → ${r.end_date?.slice(0, 10) || '—'}`
            : `${r.days_ahead} día(s)`;

    const typeLabel = (r) =>
        r.type === "all" ? "Toda la orden" : "Solo asignados";

    const modeLabel = (r) =>
        r.limit_mode === "date_range" ? "Rango fechas" : "Días futuro";

    /* ══════════════════════════════════
       RENDER
    ══════════════════════════════════ */
    return (
        <>
            <AppShell route="config/pick-and-go">
                <MainContent>
                    <div className="png-page">

                        {/* ── PAGE HEADER ── */}
                        <div className="png-page-header">
                            <div>
                                <p className="png-eyebrow">Configuración</p>
                                <h1 className="png-page-title">Pick & Go</h1>
                                <p className="png-page-sub">Gestión de reglas de retiro programado</p>
                            </div>
                            <button className="png-btn-new" onClick={openCreate}>
                                <IcoPlus /> Nueva regla
                            </button>
                        </div>

                        {/* ── TABLE CARD ── */}
                        <div className="png-card">

                            {/* ── TABLA DESKTOP ── */}
                            <div className="png-table-wrap">
                                {rows.length === 0 ? (
                                    <div className="png-empty">
                                        <div className="png-empty-icon"><IcoPng /></div>
                                        <p className="png-empty-title">Sin configuraciones</p>
                                        <p className="png-empty-sub">Crea tu primera regla Pick & Go con el botón de arriba.</p>
                                    </div>
                                ) : (
                                    <table className="png-table">
                                        <thead>
                                            <tr>
                                                <th>Activa</th>
                                                <th>Nombre</th>
                                                <th>Sucursal</th>
                                                <th>Ventana (min)</th>
                                                <th>Horario</th>
                                                <th>Límite</th>
                                                <th>Anticip. (min)</th>
                                                <th>Prior.</th>
                                                <th>Tipo</th>
                                                <th>Modo</th>
                                                <th style={{ textAlign: 'right' }}>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map(r => (
                                                <tr key={r.id}>
                                                    <td>
                                                        {Number(r.is_active)
                                                            ? <span className="png-badge-active"><IcoCheck /> Sí</span>
                                                            : <span className="png-badge-inactive"><IcoSlash /> No</span>}
                                                    </td>
                                                    <td className="png-td-name">{r.name}</td>
                                                    <td>{r.branchoffice_name ?? 'General negocio'}</td>
                                                    <td>{r.slot_minutes}</td>
                                                    <td>{r.window_start}–{r.window_end}</td>
                                                    <td>{limitLabel(r)}</td>
                                                    <td>{r.lead_time_minutes}</td>
                                                    <td>{r.priority}</td>
                                                    <td>{typeLabel(r)}</td>
                                                    <td>{modeLabel(r)}</td>
                                                    <td>
                                                        <div className="png-action-row">
                                                            <button className="png-btn-edit" onClick={() => openEdit(r)}>
                                                                <IcoPen /> Editar
                                                            </button>
                                                            <RenderIf isTrue={r.type === "product"}>
                                                                <button className="png-btn-products" onClick={() => openProducts(r)}>
                                                                    <IcoBox /> Productos
                                                                </button>
                                                            </RenderIf>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* ── MOBILE CARDS ≤700px ── */}
                            <div className="png-mobile-grid">
                                {rows.length === 0 ? (
                                    <div className="png-empty">
                                        <div className="png-empty-icon"><IcoPng /></div>
                                        <p className="png-empty-title">Sin configuraciones</p>
                                        <p className="png-empty-sub">Crea tu primera regla Pick & Go.</p>
                                    </div>
                                ) : rows.map((r, i) => (
                                    <div className="png-rule-card" key={r.id} style={{ animationDelay: `${i * 0.04}s` }}>
                                        <div className="png-rule-card-head">
                                            <div>
                                                <div className="png-rule-card-name">{r.name}</div>
                                                <div className="png-rule-card-branch">{r.branchoffice_name ?? 'General negocio'}</div>
                                            </div>
                                            {Number(r.is_active)
                                                ? <span className="png-badge-active"><IcoCheck /> Activa</span>
                                                : <span className="png-badge-inactive"><IcoSlash /> Inactiva</span>}
                                        </div>
                                        <div className="png-rule-card-grid">
                                            <div>
                                                <div className="png-rule-chip-label">Horario</div>
                                                <div className="png-rule-chip-val">{r.window_start}–{r.window_end}</div>
                                            </div>
                                            <div>
                                                <div className="png-rule-chip-label">Ventana (min)</div>
                                                <div className="png-rule-chip-val">{r.slot_minutes}</div>
                                            </div>
                                            <div>
                                                <div className="png-rule-chip-label">Anticipación</div>
                                                <div className="png-rule-chip-val">{r.lead_time_minutes} min</div>
                                            </div>
                                            <div>
                                                <div className="png-rule-chip-label">Límite</div>
                                                <div className="png-rule-chip-val">{limitLabel(r)}</div>
                                            </div>
                                        </div>
                                        <div className="png-rule-card-actions">
                                            <button className="png-btn-edit" onClick={() => openEdit(r)}>
                                                <IcoPen /> Editar
                                            </button>
                                            <RenderIf isTrue={r.type === "product"}>
                                                <button className="png-btn-products" onClick={() => openProducts(r)}>
                                                    <IcoBox /> Productos
                                                </button>
                                            </RenderIf>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                        {/* end png-card */}

                        {/* ── MODAL crear / editar — Bootstrap Modal con CSS overrides ── */}
                        <Modal show={show} onHide={() => setShow(false)} centered dialogClassName="png-dialog">
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {editing?.id ? 'Editar' : 'Nueva'} Configuración
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {editing && (
                                    <Form>
                                        <Row className="g-3">
                                            <Col md={12}>
                                                <Form.Label>Sucursal</Form.Label>
                                                <Form.Select
                                                    value={editing.branchoffice_id ?? 'null'}
                                                    onChange={e => setEditing({ ...editing, branchoffice_id: e.target.value === 'null' ? null : e.target.value })}
                                                >
                                                    <option value="null">General del negocio</option>
                                                    {branches.map(b => (
                                                        <option key={b.branchoffice_id} value={b.branchoffice_id}>{b.branchoffice_name}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Label>Nombre</Form.Label>
                                                <Form.Control type="text" value={editing.name || ''}
                                                    onChange={e => setEditing({ ...editing, name: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label>Lapso (min)</Form.Label>
                                                <Form.Control type="number" value={editing.slot_minutes}
                                                    onChange={e => setEditing({ ...editing, slot_minutes: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label>Desde</Form.Label>
                                                <Form.Control type="time" value={editing.window_start}
                                                    onChange={e => setEditing({ ...editing, window_start: e.target.value })} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label>Hasta</Form.Label>
                                                <Form.Control type="time" value={editing.window_end}
                                                    onChange={e => setEditing({ ...editing, window_end: e.target.value })} />
                                            </Col>
                                            <Col md={6}>
                                                <Form.Label>Modo de límite</Form.Label>
                                                <Form.Select
                                                    value={editing.limit_mode || 'days_ahead'}
                                                    onChange={e => setEditing({
                                                        ...editing,
                                                        limit_mode: e.target.value,
                                                        days_ahead: e.target.value === "days_ahead" ? (editing.days_ahead || 7) : "",
                                                        start_date: e.target.value === "date_range" ? (editing.start_date || "") : "",
                                                        end_date: e.target.value === "date_range" ? (editing.end_date || "") : ""
                                                    })}
                                                >
                                                    <option value="days_ahead">Días a futuro</option>
                                                    <option value="date_range">Rango de fechas</option>
                                                </Form.Select>
                                            </Col>
                                            <RenderIf isTrue={(editing.limit_mode || "days_ahead") === "days_ahead"}>
                                                <Col md={6}>
                                                    <Form.Label>Días a futuro</Form.Label>
                                                    <Form.Control type="number" value={editing.days_ahead}
                                                        onChange={e => setEditing({ ...editing, days_ahead: e.target.value })} />
                                                </Col>
                                            </RenderIf>
                                            <RenderIf isTrue={(editing.limit_mode || "days_ahead") === "date_range"}>
                                                <>
                                                    <Col md={6}>
                                                        <Form.Label>Fecha inicio</Form.Label>
                                                        <Form.Control type="date" value={editing.start_date || ""}
                                                            onChange={e => setEditing({ ...editing, start_date: e.target.value })} />
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Label>Fecha fin</Form.Label>
                                                        <Form.Control type="date" value={editing.end_date || ""}
                                                            onChange={e => setEditing({ ...editing, end_date: e.target.value })} />
                                                    </Col>
                                                </>
                                            </RenderIf>
                                            <Col md={6}>
                                                <Form.Label>Tiempo preparación (min)</Form.Label>
                                                <Form.Control type="number" value={editing.lead_time_minutes}
                                                    onChange={e => setEditing({ ...editing, lead_time_minutes: e.target.value })} />
                                            </Col>
                                            <Col md={6}>
                                                <Form.Label>Nivel de prioridad</Form.Label>
                                                <Form.Control type="number" value={editing.priority}
                                                    onChange={e => setEditing({ ...editing, priority: e.target.value })} />
                                            </Col>
                                            <Col md={6}>
                                                <Form.Label>Tipo de regla</Form.Label>
                                                <Form.Select value={editing.type || 'all'}
                                                    onChange={e => setEditing({ ...editing, type: e.target.value })}>
                                                    <option value="all">Todos los productos</option>
                                                    <option value="product">Solo productos asignados</option>
                                                </Form.Select>
                                            </Col>
                                            <RenderIf isTrue={!!editing.id}>
                                                <Col md={12}>
                                                    <div className={`png-toggle-card ${editing.is_active ? 'is-on' : 'is-off'}`}>
                                                        {/* info lado izquierdo */}
                                                        <div className="png-toggle-left">
                                                            <div className="png-toggle-label">Estado de la regla</div>
                                                            <div className="png-toggle-desc">
                                                                {editing.is_active
                                                                    ? 'Activa — se aplicará a los pedidos que cumplan las condiciones.'
                                                                    : 'Inactiva — no afectará ningún pedido hasta que la reactives.'}
                                                            </div>
                                                        </div>
                                                        {/* badge animado + switch */}
                                                        <div className="png-toggle-right">
                                                            {/* key cambia con el estado → re-monta → dispara la animación */}
                                                            <span
                                                                key={String(editing.is_active)}
                                                                className={`png-toggle-status ${editing.is_active ? 'on' : 'off'}`}
                                                            >
                                                                {editing.is_active ? '✓ Activada' : '✗ Desactivada'}
                                                            </span>
                                                            {/* Form.Check original — lógica intacta */}
                                                            <Form.Check
                                                                type="switch"
                                                                label=""
                                                                checked={!!editing.is_active}
                                                                onChange={e => setEditing({ ...editing, is_active: e.target.checked })}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            </RenderIf>
                                        </Row>
                                    </Form>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShow(false)}>Cancelar</Button>
                                <Button variant="primary" onClick={save}>Guardar</Button>
                            </Modal.Footer>
                        </Modal>

                        {/* ── AssignProductsModal — props originales intactos ── */}
                        <AssignProductsModal
                            show={showProducts}
                            onHide={() => setShowProducts(false)}
                            rule={ruleForProducts}
                            businessId={business?.id}
                            token={token}
                        />

                        {/* ── Bootstrap Card/Table originales ocultos — preserva las importaciones ── */}
                        <div style={{ display: 'none' }}>
                            <Container className="py-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h4>Pick & Go – Configuración</h4>
                                    <Button onClick={openCreate}>+ Nueva</Button>
                                </div>
                                <Card><Card.Body>
                                    <Table size="sm" hover>
                                        <thead><tr>
                                            <th>Activa</th><th>Nombre</th><th>Sucursal</th>
                                            <th>Duración de cada ventana (minutos)</th><th>Horario de disponibilidad</th>
                                            <th>Límite de reserva</th><th>Anticipación mínima para pedir (minutos)</th>
                                            <th>Prioridad</th><th>Tipo de regla</th><th>Modo de límite</th><th>Acciones</th>
                                        </tr></thead>
                                        <tbody>
                                            {rows.map(r => (
                                                <tr key={r.id}>
                                                    <td>{Number(r.is_active) ? <Badge bg="success">Sí</Badge> : <Badge bg="secondary">No</Badge>}</td>
                                                    <td>{r.name}</td>
                                                    <td>{r.branchoffice_name ?? "General negocio"}</td>
                                                    <td>{r.slot_minutes}</td>
                                                    <td>{r.window_start}–{r.window_end}</td>
                                                    <td>{r.limit_mode === "date_range" ? `${r.start_date?.slice(0, 10) || '-'} a ${r.end_date?.slice(0, 10) || '-'}` : `${r.days_ahead} día(s)`}</td>
                                                    <td>{r.lead_time_minutes}</td>
                                                    <td>{r.priority}</td>
                                                    <td>{r.type === "all" ? "Toda la orden" : "Solo productos asignados"}</td>
                                                    <td>{r.limit_mode === "date_range" ? "Rango de fechas" : "Días a futuro"}</td>
                                                    <td className="text-end">
                                                        <Button size="sm" variant="outline-primary" onClick={() => openEdit(r)}>Editar</Button>
                                                        <RenderIf isTrue={r.type === "product"}>
                                                            <Button size="sm" variant="outline-primary" onClick={() => openProducts(r)}>Agregar productos</Button>
                                                        </RenderIf>
                                                    </td>
                                                </tr>
                                            ))}
                                            {!rows.length && <tr><td colSpan={7} className="text-center text-muted">Sin configuraciones</td></tr>}
                                        </tbody>
                                    </Table>
                                </Card.Body></Card>
                            </Container>
                        </div>

                    </div>
                </MainContent>
            </AppShell>


        </>
    );
};

export default PickAndGoManager;